import { render, staticRenderFns } from "./add-advertising-format.vue?vue&type=template&id=16e1690e&scoped=true&"
import script from "./add-advertising-format.vue?vue&type=script&lang=js&"
export * from "./add-advertising-format.vue?vue&type=script&lang=js&"
import style0 from "./add-advertising-format.vue?vue&type=style&index=0&id=16e1690e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e1690e",
  null
  
)

export default component.exports